import React from "react";

export default function MuncipalityFees(props:any) {

    const { details } = props;

    return (
        <div style={{ boxSizing: 'border-box' }}>
            <div style={{ padding: '40px 24px', borderBottom: '1px solid #E8E8E8' }}>
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <span className="text-3E3E3E-18px">Rental Registration</span>
                    <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                        {
                            Object.keys(details['rentalRegistration']).map((title: string, index:number) => {
                                    return (
                                        <div key={index} style={{ width: '157px', display: 'flex', flexDirection: 'column', marginTop: '24px', marginRight: '24px' }}>
                                            <span className="text-787878-14px">{title}</span>
                                            <span className="text-303030-16px">{details['rentalRegistration'][title]}</span>
                                        </div>
                                    )
                                })
                        }
                    </div>
                </div>
            </div>
            <div style={{ padding: '40px 24px', display: 'flex'}}>
                <div className="mf-left-container">
                    <div className="mf-free-amount-container" style={{ width:'305px'}}>
                        <span className="text-3E3E3E-18px">Fee Amounts</span>
                        <div style={{ marginTop: '16px' }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                <span className="text-787878-14px">Renewal Processing Fee</span>
                                <span className="text-303030-14px">{`$${details['renewalProcessingFee']}`}</span>
                            </div>
                            <div style={{ display: 'flex', justifyContent: 'space-between', margin:'16px 0px' }}>
                                <span className="text-787878-14px">Application Fee</span>
                                <span className="text-303030-14px">{`$${details['applicationFee']}`}</span>
                            </div>
                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                <span className="text-787878-14px">State Mandated Fee</span>
                                <span className="text-303030-14px">{`$${details['stateMandateFee']}`}</span>
                            </div>
                            <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '16px' }}>
                                <span className="text-787878-14px">Renewal Fee</span>
                                <span className="text-303030-14px">{`$${details['renewalFee']}`}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="mf-right-container">
                    <div>
                        <span className="text-3E3E3E-18px">Tax Schedule and Penalty</span>
                        <div style={{ marginTop: '16px' }}>
                            <div style={{display: 'flex', marginBottom:"26px" }}>
                                <div style={{width: '150px'}}  className="text-787878-14px">Residential Landlord Tax Schedule</div>
                                <div style={{width: '350px'}}  className="text-303030-14px">{`${details['residentialLandlordTaxSchedule']}`}</div>
                            </div>
                            <div style={{display: 'flex'}}>
                                <div style={{width: '150px'}} className="text-787878-14px">Penalty %</div>
                                <div style={{width: '350px'}} className="text-303030-14px">{`${details['penalty']}`}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}